import { createContext } from "react";

const ToastContext = createContext({
  toasts: null,
  setToasts: () => {},
});

export default ToastContext;
